import Echo from 'laravel-echo';

export default Echo;



// WEBPACK FOOTER //
// ./src/index.js